const abonos = state => state.abonos;
const tipoabono = state => state.tipoabono;
const abonoserie = state => state.abonoserie;

export default {
  abonos,
  tipoabono,
  abonoserie,
};